import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content sub" }
const _hoisted_4 = { class: "scbd co-default" }
const _hoisted_5 = { class: "head" }
const _hoisted_6 = { class: "nav" }
const _hoisted_7 = { class: "list_board" }
const _hoisted_8 = {
  cellspacing: "0",
  border: "0"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "no" }
const _hoisted_11 = { class: "subject" }
const _hoisted_12 = { class: "name inline" }
const _hoisted_13 = { class: "date inline" }
const _hoisted_14 = {
  key: 1,
  colspan: "4",
  style: {"text-align":"center"}
}
const _hoisted_15 = {
  key: 0,
  class: "pagination-controls",
  style: {"margin-top":"15px","text-align":"center"}
}
const _hoisted_16 = { style: {"margin":"0 10px"} }

import { onMounted, ref, computed, watch } from "vue";

import Loading from "@/components/Loading.vue"; // Loading 컴포넌트 임포트
import { getCallable, makeCallApiParam } from "@/config/env";
import Navbar from "@/views/etc/Navbar.vue";
import Sidebar from "@/views/etc/bbs/Sidebar.vue";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { Board } from "@/model/board";

import { useMessage, useNotification, useDialog } from "naive-ui";
import { usePagination } from "@/composables/usePagination";

const getNotices = "getBoards";

const pageSize = 10; // 페이지 크기를 상수로 정의

export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const message = useMessage();
const notification = useNotification();
const dialog = useDialog();
const getCallApiCallable = getCallable("callApi");
const isLoading = ref<boolean>(false);
const searchQuery = ref(""); // 검색어 상태 추가
const isSearchFormOpen = ref(false); // 검색창 표시 여부 상태

const {
  paginatedItems: noticeList,
  listLoading,
  error,
  currentPage,
  hasNextPage,
  goToNextPage: composableGoToNextPage,
  goToPreviousPage: composableGoToPreviousPage,
  refreshData: composableRefreshNotices,
} = usePagination<Board, { searchKey?: string; searchValue?: string }>(
  async (params) =>
    getCallApiCallable(
      makeCallApiParam(getNotices, {
        ...params,
        searchKey: "title",
        searchValue: searchQuery.value,
        type: constant.boardType.NOTICE,
      })
    ),
  pageSize
);

async function wrappedRefreshNotices() {
  await composableRefreshNotices();
}

async function wrappedGoToNextPage() {
  if (hasNextPage.value) {
    await composableGoToNextPage();
  }
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value > 1) {
    await composableGoToPreviousPage();
  }
}
const toggleSearchForm = () => {
  isSearchFormOpen.value = !isSearchFormOpen.value;
};

function performSearch() {
  // 검색 실행 시 첫 페이지부터 다시 로드하도록 refreshData 호출
  composableRefreshNotices(true); // true를 전달하여 페이지를 1로 리셋
}

onMounted(() => {
  wrappedRefreshNotices();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "etc",
      subtitle: "etc",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createVNode(Navbar),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(Loading, null, null, 512), [
        [_vShow, isLoading.value]
      ]),
      _createVNode(Sidebar),
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "sub_subject" }, [
          _createTextVNode("공지사항"),
          _createElementVNode("span")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    class: "searchFormToggle gbg",
                    onClick: toggleSearchForm
                  }, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", null, "검색", -1)),
                    _createElementVNode("i", {
                      class: _normalizeClass(["sp-ico", { 'is-open': isSearchFormOpen.value }])
                    }, null, 2)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["searchForm", { on: isSearchFormOpen.value }])
            }, [
              _createElementVNode("form", {
                name: "search_form",
                method: "get",
                action: "https://www.cokolab.com/bbs_shop/list.htm",
                onSubmit: _withModifiers(performSearch, ["prevent"])
              }, [
                _cache[4] || (_cache[4] = _createStaticVNode("<input type=\"hidden\" name=\"list_mode\" value=\"board\" data-v-25c711bc><input type=\"hidden\" name=\"cate_sub_idx\" value=\"0\" data-v-25c711bc><input type=\"hidden\" name=\"search_first_subject\" value=\"\" data-v-25c711bc><input type=\"hidden\" name=\"board_code\" value=\"notice\" data-v-25c711bc><input type=\"hidden\" name=\"me_popup\" value=\"0\" data-v-25c711bc><input type=\"hidden\" name=\"auto_frame\" value=\"\" data-v-25c711bc>", 6)),
                _createElementVNode("fieldset", null, [
                  _cache[2] || (_cache[2] = _createElementVNode("legend", { class: "blind" }, "게시물 검색", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "search_key",
                    maxlength: "30",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                    placeholder: "검색어"
                  }, null, 512), [
                    [_vModelText, searchQuery.value]
                  ]),
                  _cache[3] || (_cache[3] = _createElementVNode("button", {
                    type: "submit",
                    class: "sp-ico"
                  }, "검색", -1))
                ])
              ], 32)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _cache[6] || (_cache[6] = _createElementVNode("caption", null, " List of articles ", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    class: "no"
                  }, "번호"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "subject"
                  }, "제목"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "name"
                  }, "작성자"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "date"
                  }, "작성일")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (!_unref(listLoading))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!_unref(noticeList) || _unref(noticeList).length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_9, _cache[5] || (_cache[5] = [
                            _createElementVNode("td", {
                              colspan: "4",
                              style: {"text-align":"center"}
                            }, " 게시글이 없습니다. ", -1)
                          ])))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(noticeList), (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: item.SK
                            }, [
                              _createElementVNode("td", _hoisted_10, _toDisplayString((_unref(currentPage) - 1) * pageSize + (index + 1)), 1),
                              _createElementVNode("td", _hoisted_11, [
                                _createVNode(_component_router_link, {
                                  to: {
                          name: _unref(USER_ROUTES).Notice.Content.Name,
                          params: { id: item.SK },
                        }
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(item.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _createElementVNode("td", _hoisted_12, _toDisplayString(item.author), 1),
                              _createElementVNode("td", _hoisted_13, _toDisplayString(common.getYYYYMMDD2(item.createdDate)), 1)
                            ]))
                          }), 128))
                    ], 64))
                  : (_openBlock(), _createElementBlock("td", _hoisted_14, " 게시글 조회 중입니다. "))
              ])
            ])
          ]),
          (_unref(noticeList).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_n_button, {
                  onClick: wrappedGoToPreviousPage,
                  disabled: _unref(currentPage) === 1,
                  style: {"margin-right":"8px"}
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode(" 이전 페이지 ")
                  ])),
                  _: 1
                }, 8, ["disabled"]),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(currentPage)) + " 페이지", 1),
                _createVNode(_component_n_button, {
                  onClick: wrappedGoToNextPage,
                  disabled: !_unref(hasNextPage)
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode(" 다음 페이지 ")
                  ])),
                  _: 1
                }, 8, ["disabled"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})